import React,{useState,useEffect} from 'react'
import {Box } from 'grommet'
import { withRouter } from 'react-router-dom';
import AccountForm from '../../../components/accountForm'
import { NavigationSnackBar, ReturnAddress,LoadLayer} from '../../../components/utils/shared/shared';
import {APIRequest} from '../../../components/utils/shared/requests'
import { API,Auth } from 'aws-amplify';

function EditCustomer (props) {
  const [customer, setCustomer] = useState();
  const [load, setLoad] = useState(true); 
  useEffect(() => {     
    APIRequest(`/customers/${props.match.params.customer_id}`).then(result => {setCustomer(result); setLoad(false)})
   },[]);
   const setOrg = () => {
    return null
  }

    const handleSubmit = () => {
        setLoad(true)
        const updatedLab = ReturnAddress(customer, 'customer', 'edit')
        Auth.currentSession().then(session => {
          API
          .put("LabShip", `/customers/${customer.id}`,
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{customer: updatedLab}})
          .then(shipment => {
            setLoad(false)
            props.history.push({pathname: '/admin/customers/all', customerSucc: true, edit:true})
         })
        })
      }
  return (
   <Box>
      {(load ? <LoadLayer load={load} label={'Loading Customer'} />: 
      <Box>
        <NavigationSnackBar title={`Edit Customer: ${customer.name}`} user={props.user} pages={[{name: 'Dashboard',link: '/dashboard'},{name: 'Customers', link: '/customers/all'}]}  />
      <Box alignSelf='center' elevation='medium' direction='column' margin='small' round width='xxlarge'>
        <AccountForm setOrg={setOrg} value={customer} user={props.user} label={'Update Customer'} account={customer} customer={customer} showQuote={customer.lab.display_quote} lab={customer.lab} load={load} handleSubmit={handleSubmit} setAccount={setCustomer} />
        </Box>
      </Box>
      )}
    </Box>
  )
}

export default withRouter(EditCustomer)
